import { render } from "./BackofficeDataTable.vue?vue&type=template&id=d1b600f4&scoped=true"
import script from "./BackofficeDataTable.vue?vue&type=script&lang=js"
export * from "./BackofficeDataTable.vue?vue&type=script&lang=js"

import "./BackofficeDataTable.vue?vue&type=style&index=0&id=d1b600f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b600f4"]])

export default __exports__